// The NON wordmark as raw SVG path data, shared by the on-screen Logotype and
// the canvas-rendered share card. Never translated, never restyled.
export const WORDMARK_VIEWBOX = { w: 446.14, h: 142.83 }

export const WORDMARK_PATHS = [
  'M311,3.27,382.86,114h.38V3.27h17.22V139.8h-19.9L309.23,30.21h-.38V139.8H291.63V3.27ZM139.11,44.62a67.51,67.51,0,0,1,12.33-22.85A60.24,60.24,0,0,1,171.91,5.9Q184.15,0,200.41,0T228.9,5.93a60.37,60.37,0,0,1,20.47,15.84A67.86,67.86,0,0,1,261.7,44.62a89.92,89.92,0,0,1,0,53.75,67.86,67.86,0,0,1-12.33,22.85A59.31,59.31,0,0,1,228.9,137q-12.24,5.82-28.49,5.83T171.91,137a59.31,59.31,0,0,1-20.47-15.78,67.42,67.42,0,0,1-12.33-22.85,89.92,89.92,0,0,1,0-53.75m16.73,47.24a55.56,55.56,0,0,0,8.41,18.07A43.32,43.32,0,0,0,179,122.84q9,4.88,21.43,4.87t21.42-4.87a43.32,43.32,0,0,0,14.73-12.91A55.61,55.61,0,0,0,245,91.85a78.79,78.79,0,0,0,0-40.73A55.61,55.61,0,0,0,236.56,33a43.19,43.19,0,0,0-14.73-12.9q-9-4.89-21.42-4.88T179,20.14a43.15,43.15,0,0,0-14.73,13,55.42,55.42,0,0,0-8.41,18.06,78.79,78.79,0,0,0,0,40.73M19.87,3.27,91.78,114h.38V3.27h17.23V139.8H89.48L18.15,30.21h-.39V139.8H.55V3.27Z',
  'M419.57,5.36H414V3.47h13.48V5.36h-5.62v15h-2.24Z',
  'M429.34,3.47h3.08l5.31,14.17,5.34-14.17h3.07V20.33H444V6.3h0l-5.27,14h-1.91l-5.27-14h0v14h-2.13Z',
]

// Draw the wordmark onto a canvas context at a target width, in the given colour.
// Returns the rendered height so callers can lay out beneath it.
export function drawWordmark(ctx, x, y, targetWidth, colour = '#ffffff') {
  const scale = targetWidth / WORDMARK_VIEWBOX.w
  ctx.save()
  ctx.translate(x, y)
  ctx.scale(scale, scale)
  ctx.fillStyle = colour
  for (const d of WORDMARK_PATHS) ctx.fill(new Path2D(d))
  ctx.restore()
  return WORDMARK_VIEWBOX.h * scale
}
